import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import validationConfig from './validationConfig'
import CustomCollapse from '../../CustomCollapse'
import { SelectField, TextArea } from '../../FormFields'
import CheckIcon from '../../../../assets/icons/check-icon.svg'
import ErrorIcon from '../../../../assets/icons/exclamation-icon.svg'
import FormValidators from '../../../../helpers/FormValidators'
import { getReleasesForApplication } from '../../../../redux/actions/release'

const VersionInfoForm = ({ formState, globalApplicationId, disabled, isApplicationView = false, isInternalApp = false }) => {
  // ===== Form state =====
  const { formData, formErrors, onFormDataChanged, validateFormField } = formState

  // ===== Redux state =====
  const history = useHistory()
  const dispatch = useDispatch()
  const releasesForApp = useSelector(({ release }) => release.releasesForApp)
  const isFetchingReleasesForApp = useSelector(({ release }) => release.isFetchingReleasesForApp)

  // ===== Side effects =====
  useEffect(() => {
    if (!isFetchingReleasesForApp && globalApplicationId) {
      const additionalODataFilter = isApplicationView ? "and (Status eq 'Approved' or Status eq 'Live' or Status eq 'Expired')" : null
      dispatch(getReleasesForApplication(globalApplicationId, additionalODataFilter))
    }
  }, [globalApplicationId])

  //  ===== Methods =====
  const onChange = (key, value) => {
    if (key === "releaseId") {
      const path = history.location?.pathname?.replace(/[0-9]/g, '')
      history.push(`${path}${value}`)
      return
    }
    onFormDataChanged(key, value)
    validateFormField(key, value, validationConfig)
  }

  return (
    <CustomCollapse
      title="Version information"
      icon={FormValidators.checkFormValidity(formErrors, validationConfig) ? CheckIcon : ErrorIcon}
    >
      <SelectField
        displayName="Release version"
        placeholder="Select release version"
        description="You can choose the release version that you would like to view/edit"
        onChange={(value) => onChange("releaseId", value)}
        errorMessage={formErrors["releaseId"]?.message}
        options={Array.isArray(releasesForApp) ?
          releasesForApp?.map((release) => ({ value: release.id, displayName: `v${release.version?.toFixed(1)}` })) : []
        }
        value={formData["releaseId"]}
        optionsLoading={isFetchingReleasesForApp}
      />
      {!isInternalApp && (
        <>
          <TextArea
            displayName="Release Notes"
            placeholder="The notes you enter here will be shown to the reviewer"
            onChange={(value) => onChange("commentByVendor", value)}
            errorMessage={formErrors["commentByVendor"]?.message}
            value={formData["commentByVendor"]}
            disabled={disabled}
          />
          <TextArea
            displayName="Reviewer Notes"
            description="Notes added by reviewer will appear here"
            value={formData["commentByAdmin"]}
            disabled={true}
          />
        </>
      )}
    </CustomCollapse>
  )
}

export default VersionInfoForm
